import React, { ChangeEventHandler } from 'react';

export function Input({
  onChange,
  value,
  type,
  name,
  placeholder,
}: {
  onChange: ChangeEventHandler<HTMLInputElement>;
  value: HTMLInputElement['value'];
  type?: HTMLInputElement['type'];
  name?: HTMLInputElement['name'];
  placeholder?: HTMLInputElement['placeholder'];
}) {
  return (
    <input
      className="border border-white px-1 w-full"
      type={type || 'text'}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}
